import { axios } from '@/lib/axios';

export const deleteCorp = async (id: number) => {
    const { success, message } = await axios.post(`v1/update-corporation/${id}`, {
        corporate_active: false,
    });
    return { success, message };
};
